export const biteClassificationFields = ['rightMolar', 'leftMolar', 'rightCanine', 'leftCanine']
export const biteClassificationValues = ['I', 'II', 'III', 'uncertain']

// 50 scans per page. Older history than this is not worth a page walk on every Copilot mount.
export const LATEST_BITE_CLASSIFICATION_MAX_PAGES = 6

export const isCompleteBiteClassification = value =>
  !!value && biteClassificationFields.every(field => biteClassificationValues.includes(value[field]))

export const parseBiteClassification = trackingDetails => {
  try {
    const details = typeof trackingDetails === 'string' ? JSON.parse(trackingDetails) : trackingDetails
    return !details?.isDismissed && isCompleteBiteClassification(details?.biteClassification)
      ? details.biteClassification
      : null
  } catch {
    return null
  }
}

const parseFlags = doctor => {
  try {
    const flags = JSON.parse(doctor?.user?.featureFlags?.flags || '{}')
    return flags && typeof flags === 'object' && !Array.isArray(flags) ? flags : {}
  } catch {
    return {}
  }
}

// biteClassification is a practice-wide flag (isPractice in useAllFeatureFlags): the account
// owner's FeatureFlags row overrides each member's own row, same as useFeatureFlags does for
// the signed-in practice. The patient's doctor may be a member, so resolve the owner first.
export const resolvePracticeBiteClassificationFlag = async (doctorId, fetchDoctor) => {
  const doctorResult = await fetchDoctor(doctorId)
  if (doctorResult.error) return doctorResult
  const doctor = doctorResult.data?.getDoctor
  if (!doctor) return { error: { message: `doctor ${doctorId} not found` } }

  const accountOwnerId = doctor.accountOwnerId || doctor.id
  let owner = doctor
  if (accountOwnerId !== doctor.id) {
    const ownerResult = await fetchDoctor(accountOwnerId)
    if (ownerResult.error) return ownerResult
    owner = ownerResult.data?.getDoctor
    if (!owner) return { data: false }
  }

  const flagSource = owner.user?.featureFlags?.flags ? owner : doctor
  return { data: parseFlags(flagSource).biteClassification === true }
}

// DynamoDB can return an empty filtered page with a nextToken.
export const fetchLatestBiteClassification = async (fetchPage, maxPages = LATEST_BITE_CLASSIFICATION_MAX_PAGES) => {
  let nextToken
  let pages = 0
  do {
    const result = await fetchPage(nextToken)
    if (result.error) return result
    const page = result.data.grinScansByPatientIdSorted
    for (const scan of page.items || []) {
      const biteClassification = parseBiteClassification(scan?.trackingDetails)
      if (!scan?._deleted && scan?.trackingStatus === 'submitted' && biteClassification) {
        return { data: { scanId: scan.id, createdAt: scan.createdAt, biteClassification } }
      }
    }
    nextToken = page.nextToken
    pages += 1
  } while (nextToken && pages < maxPages)
  return { data: null }
}
